var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-autocomplete', {
    staticClass: "country-dropdown",
    attrs: {
      "items": _vm.items,
      "value": _vm.selectedIso2,
      "item-text": "name",
      "item-value": "iso2",
      "label": "Country",
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "auto-select-first": "",
      "menu-props": {
        dark: _vm.$vuetify.theme.dark,
        offsetY: true
      }
    },
    on: {
      "change": _vm.onChange
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('span', {
          staticClass: "country-selection"
        }, [_vm.enabledFlags ? _c('span', {
          staticClass: "country-flag fi",
          class: _vm.flagClass(item.iso2)
        }) : _vm._e(), _c('span', {
          staticClass: "country-name"
        }, [_vm._v(_vm._s(item.name))]), _vm.enabledCountryCode && item.dialCode ? _c('span', {
          staticClass: "country-dial"
        }, [_vm._v("+" + _vm._s(item.dialCode))]) : _vm._e()])];
      }
    }, {
      key: "item",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm.enabledFlags ? _c('span', {
          staticClass: "country-flag fi",
          class: _vm.flagClass(item.iso2)
        }) : _vm._e(), _c('span', {
          staticClass: "country-name"
        }, [_vm._v(_vm._s(item.name))]), _vm.enabledCountryCode && item.dialCode ? _c('span', {
          staticClass: "country-dial"
        }, [_vm._v("+" + _vm._s(item.dialCode))]) : _vm._e()];
      }
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }